import moment from 'moment';
import useStandardProlongDeal from '../hooks/useStandardProlongDeal';
import useGlobalProlongDeal from '../hooks/useGlobalProlongDeal';
import useCreditonGlobalProlongDeal from '../hooks/useCreditonGlobalProlongDeal';
import { prolongDate } from '../../../../../helpers/data-constants';

const useProlongCalculator = (config) => {
  const standardProlongDeal = useStandardProlongDeal(config);
  const globalProlongDeal = useGlobalProlongDeal(config);
  const creditonProlongDeal = useCreditonGlobalProlongDeal(config);

  return (deal) => {
    const newProlongDate = config.isExtensionThreeImplementaition 
      ? prolongDate.crediton.NEW_PROLONG_DATE 
      : prolongDate.visem.NEW_PROLONG_DATE;

    const isNewGlobalProlong = moment(deal?.startDate).isAfter(newProlongDate);

    let calculator;

    if (config.isExtensionThreeImplementaition && isNewGlobalProlong) {
      // calculator for Crediton global prolong
      calculator = {
        calculateDateDefault: creditonProlongDeal.calculateDateDefault,
        baseExtensionDate: (deal) => globalProlongDeal.baseExtensionDate(deal)
      };
    } else if (isNewGlobalProlong) {
      // calculator for Visem global prolong
      calculator = {
        calculateDateDefault: globalProlongDeal.calculateDateDefault,
        baseExtensionDate: (deal) =>  globalProlongDeal.baseExtensionDate(deal)
      };
    } else {
      // calculator for standard prolong
      calculator = {
        calculateDateDefault: standardProlongDeal.calculateDateDefault,
        baseExtensionDate: (deal) => standardProlongDeal.baseExtensionDate(deal)
      };
    }

    return calculator;
  };
};

export default useProlongCalculator;